// LICENSE_CODE ZON
'use strict'; /*jslint browser:true, es6:true, node:true, react:true*/
import React from 'react';

interface i_select_config {
    selected_icon?: React.ReactNode;
    dropdown_icon?: React.ReactNode;
    country_flags_url?: string;
    country_no_flag?: Set<string>;
}

const default_config: i_select_config = {
    selected_icon: '✓',
    dropdown_icon: '▼',
    country_flags_url: '/www/oculus/pub/img/flags/',
    country_no_flag: new Set(),
};

let config: i_select_config = {...default_config};

export const get_config = ()=>config;

export const set_config = (update: Partial<i_select_config>)=>{
    config = {...config, ...update};
    return config;
};
